import { render } from "./file-upload-monitor.vue?vue&type=template&id=4dd9b8e7&ts=true&lang=pug"
import script from "./file-upload-monitor.vue?vue&type=script&lang=ts"
export * from "./file-upload-monitor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__